import {
    applyMiddleware,
    compose,
    createStore
} from 'redux';
import { rootReducer } from './rootReducer';
import fetchMiddleware from './middleware/fetchMiddleware';
import tokenMiddleware from './middleware/tokenMiddleware';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let store;

export const getStore = () => {
    if (!store) {
        store = createStore(
            rootReducer,
            composeEnhancers(applyMiddleware(tokenMiddleware, fetchMiddleware))
        );
    }

    return store;
};
